import { create } from "zustand";
import { ProductOrderCalc } from "../pages/orders/hooks/useProductOrderCalculationQuery";

type ProductsOrderState = {
  selectedProducts: ProductOrderCalc[];
  allowCalculate: boolean;
  addProduct: (productId: string, quantity?: number) => void;
  removeProduct: (productId: string) => void;
  updateQuantity: (productId: string, quantity: number) => void;
  setSelectedProducts: (products: ProductOrderCalc[]) => void;
  setAllowCalculate: (value: boolean) => void;
  clearProducts: () => void;
};

export const useProductsOrderStore = create<ProductsOrderState>((set) => ({
  selectedProducts: [],
  allowCalculate: false,
  addProduct: (productId, quantity = 1) =>
    set((state) => {
      const existing = state.selectedProducts.find(
        (p) => p.productId === productId,
      );

      if (existing) {
        return {
          allowCalculate: true,
          selectedProducts: state.selectedProducts.map((p) =>
            p.productId === productId
              ? { ...p, quantity: p.quantity + quantity }
              : p,
          ),
        };
      }

      return {
        allowCalculate: true,
        selectedProducts: [...state.selectedProducts, { productId, quantity }],
      };
    }),
  setAllowCalculate: (value) =>
    set((state) => ({
      ...state,
      allowCalculate: value,
    })),
  removeProduct: (productId) =>
    set((state) => ({
      allowCalculate: true,
      selectedProducts: state.selectedProducts.filter(
        (p) => p.productId !== productId,
      ),
    })),

  updateQuantity: (productId, quantity) =>
    set((state) => ({
      allowCalculate: true,
      selectedProducts: state.selectedProducts.map((p) =>
        p.productId === productId ? { ...p, quantity } : p,
      ),
    })),
  setSelectedProducts: (products) => set({ selectedProducts: products }),
  clearProducts: () => set({ selectedProducts: [], allowCalculate: false }),
}));
